import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import Component from './Component';

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Component),
);
